import { inView, animate, stagger } from 'motion';

const numSections = document.querySelectorAll('.logo-section').length;

inView('.footer-trnsmt-logo', ({ target }) => {
	const offset = 0.15;
	animate(
		'.logo-section',
		{ opacity: [0, 1] },
		{
			offset: [0, 0.1, 1],
			duration: numSections * offset,
			delay: stagger(offset),
		}
	)
});
